import axios from "axios";

export const getFeaturedJobsByGroup = (careersClientId, groupId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredjobs/getJobsByGroup/" +
        encodeURIComponent(careersClientId) +
        (groupId !== undefined ? "/?groupId=" + encodeURIComponent(groupId) : "")
    )
    .then((res) => res.data);
};

export const updateFeatureJobOrder = (careersClientId, groupId, newOrder) => {
  return axios
    .put(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredjobs/updateOrder/" +
        encodeURIComponent(careersClientId) +
        (groupId !== undefined ? "/?groupId=" + encodeURIComponent(groupId) : ""),
      newOrder
    )
    .then((res) => res.data);
};

export const addJobs = (careersClientId, groupId, jobs) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredjobs/addJobs/" +
        encodeURIComponent(careersClientId) +
        (groupId !== undefined ? "/?groupId=" + encodeURIComponent(groupId) : ""),
      jobs
    )
    .then((res) => res.data);
};

export const deleteJob = (jobId) => {
  return axios
    .delete(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredjobs/deleteJob/" +
        encodeURIComponent(jobId)
    )
    .then((res) => res);
};
